import { Alert, AlertTitle, Container } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';


export default function SuccessfulAdminSignup() {

    const navigate = useNavigate("");

    setTimeout(() => {
        navigate('/admin-dashboard');
    }, 1000)
    return (

        <Container>
            <Alert style={{ marginTop: "5rem" }} severity="success">
                <AlertTitle>Congratulations</AlertTitle>
                Admin Login — <strong>successfully!</strong>
            </Alert>
        </Container>
    )
}